import CategoriesFull from './components/CategoriesFull';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import * as React from 'react';
var CategoriesOption = {
    key: 'mailCategories',
    titleStringKey: 'optionTitle_categories',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_categories',
    fullOptionFormSettings: {
        render: function () { return React.createElement(CategoriesFull, null); },
        isDirty: function () { return false; },
        onSave: function () {
            return Promise.resolve();
        },
        onDiscard: function () {
            return;
        },
        hideSaveDiscard: function () {
            return true;
        },
    },
    isHidden: function () { return !isControlFeatureEnabled('tri-categories-parity'); },
};
export default CategoriesOption;
//# sourceMappingURL=CategoriesOption.js.map